<template>
  <div>
    <v-form class="mx-5" ref="form_info">
      <template>
        <div class="pt-5">
          <v-row class="pa-0">
            <v-col cols='12' :lg="$route.name != 'NewScheduleLock' ? 8 : 12"
              :md="$route.name != 'NewScheduleLock' ? 8 : 12" class="py-0">
              <v-text-field dense outlined v-model="event.name"
                :label="$route.name == 'NewEvent' ? 'Nome do evento' : $route.name == 'NewNegotiation' ? 'Nome da negociação' : 'Nome do bloqueio'"
                :rules="required"></v-text-field>
            </v-col>
            <!-- <v-col cols='12' lg='2' md="4" class="py-2">
              <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="category_items" label="Categoria" :rules="required" v-model="event.category"></v-select>
            </v-col> -->
            <v-col cols='12' lg='4' md="4" class="py-0" v-if="$route.name != 'NewScheduleLock'">
              <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="status_items_map"
                label="Status" :rules="required" v-model="event.status"></v-select>
            </v-col>
            <v-col class="py-0" cols='12'>
              <find-user listTitle="Digite 3 letras para realizar a busca" text="Associar participantes"
                icon="mdi-account-multiple" :multi="true" @selectedChange="handleSelected" v-model="members"
                @removeItem="handleRemove"></find-user>
            </v-col>
          </v-row>
        </div>

        <v-row class="d-flex justify-start">
          <v-col align="center" cols='12' lg='3' class="py-0 pt-3" v-if="$route.name != 'NewScheduleLock'">
            <calendar-date-picker label="Data do evento" :required_date="true" @datePicked="handleDataPickStartAt"
              :date="event.start_at" />
          </v-col>

          <v-col cols='12' lg='2' class="pt-4 d-flex justify-center" style="margin-top: 1px">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small v-bind="attrs" v-on="on" tile :color="event.color || 'primary'" elevation="4"
                  class="white--text" dense>
                  <v-icon color="white">
                    mdi-brush
                  </v-icon>
                  Cor do evento
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <calendar-color-picker is_color_existe :color_prop="event.color"
                    @color='handleColor'></calendar-color-picker>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>

        <v-row v-if="$route.name == 'NewScheduleLock'">
          <!-- <span class="subtitle-activity ml-2" style="color:dimgrey">SELECIONE UMA DATA OU PERÍODO</span> -->
          <v-col cols="12" sm="12" class="pa-0">
            <div class="mt-1 px-1">
              <v-card outlined>
                <v-card-title class="v-picker__title py-1">
                  <div class="text-subtitle-1 font-weight-bold">{{ formatDateToShow }}</div>
                </v-card-title>
                <v-card-text class="px-0 pb-3">
                  <v-date-picker v-model="dates" @change="sortDates" range full-width no-title
                    style="border-radius: 0px;"></v-date-picker>
                </v-card-text>
              </v-card>
              <!-- <v-card outlined>
                <v-card-title class="py-1" style="background-color: #424242 !important;">
                  <span class="white--text text-subtitle-2">SELECIONE UMA DATA OU PERÍODO</span>
                </v-card-title>
                <v-card-text class="px-0 pb-3">
                  <v-date-picker v-model="dates" @change="sortDates" range full-width
                    :title-date-format="formatDateToShow" :year-format="formatDateToShow"></v-date-picker>
                </v-card-text>
              </v-card> -->
              <v-col>
              </v-col>
            </div>
          </v-col>
        </v-row>

        <div :class="$vuetify.breakpoint.mobile ? 'py-3' : 'd-flex mt-3'" v-if="$route.name == 'NewScheduleLock'">
          <div>
            <v-menu :offset-y="true" :offset-x="false" nudge-left="50" :close-on-content-click="false"
              v-model="menu_start_time">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" small min-width="280" label class="background-color-def" dark>
                  <v-icon left>mdi-clock-outline</v-icon>
                  {{ event.start_time ? 'INÍCIO' : 'DEFINIR HORARIO DE INÍCIO' }} <b class="ml-1">{{ event.start_time
                  }}</b>
                </v-btn>
              </template>
              <v-card>
                <v-card-text class="pa-0">
                  <v-time-picker format="24hr" v-model="event.start_time"></v-time-picker>
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="menu_start_time = false">fechar</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
          <div :class="$vuetify.breakpoint.mobile ? 'mt-3' : 'ml-3'">
            <v-menu :offset-y="true" :offset-x="false" nudge-left="50" :close-on-content-click="false"
              v-model="menu_end_time">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" small min-width="280px" label class="background-color-def" dark><v-icon
                    left>mdi-clock-outline</v-icon>
                  {{ event.end_time ? 'TÉRMINO' : 'DEFINIR HORARIO DE TÉRMINO' }} <b class="ml-1"> {{ event.end_time
                  }}</b>
                </v-btn>
              </template>
              <v-card>
                <v-card-text class="pa-0">
                  <v-time-picker format="24hr" v-model="event.end_time"></v-time-picker>
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="menu_end_time = false">fechar</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
        </div>

      </template>
      <card-loading-transparent v-if="loading"></card-loading-transparent>
      <v-btn @click="createEvent()" small dense text class="mt-4 mb-4 mr-2 btn-success">
        <v-icon left>
          mdi-content-save
        </v-icon>Salvar
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import { CurrencyDirective } from 'vue-currency-input';
import cep from 'cep-promise'
import DatePicker from 'vue2-datepicker';

export default {
  name: 'CreateEventInfos',
  mixins: [validations],
  directives: {
    currency: CurrencyDirective,
  },
  components: {
    CalendarColorPicker: () => import('../../calendar/CalendarColorPicker.vue'),
    CalendarDatePicker: () => import('../../calendar/CalendarDatePicker.vue'),
    CalendarTimePicker: () => import('../../calendar/CalendarTimePicker.vue'),
    FindUser: () => import('../../../member/FindUser.vue'),
    DatePicker,
  },
  data() {
    return {
      menu_start_time: false,
      menu_end_time: false,
      menu_data: false,
      size_items: [
        { text: 'Grande', value: 'large' },
        { text: 'Médio', value: 'medium' },
        { text: 'Pequeno', value: 'small' },
      ],
      category_items: [
        { text: 'Negociação', value: 'negotiation' },
        { text: 'Evento', value: 'event' },
        { text: 'Bloqueio de agenda', value: 'block_calendar' }
      ],
      currency: {
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree: false,
      },
      zipMask: '##.###-###',
      loading: false,
      event: {
        name: '',
        status: 'open',
        category: '',
        start_at: '',
        end_at: '',
        start_time: '',
        end_time: '',
        color: '',
        value: '',
      },
      event_detail_attributes: {
        size: '',
        zip: '',
        address: '',
        description: '',
      },
      dates: [],
      members: []
    }
  },
  mounted() {
  },
  methods: {
    handleRemove(id) {
    },
    handleSelected(e) {
    },
    sortDates() {
      return this.dates.sort()
    },
    createEvent() {
      let route_schedule = this.$route.name == 'NewScheduleLock'
      let category = this.$route.name == "NewScheduleLock" ? 'block_calendar' : 'event';

      let participants = this.members.map(el => { return el.id })

      if (route_schedule) {
        if ((this.event.end_time < this.event.start_time && (this.dates.length == 1 || this.$dayjs(this.dates[0]).isSame(this.$dayjs(this.dates[1]), 'day')))) {
          this.swallConfirmation({ msg: 'O Horario de início não pode ser maior que o término', icon: 'error' })
        }
        else if (!this.validateForm() && this.dates.length >= 1 || !this.event.end_time || !this.event.start_time) {
          this.swallConfirmation({ msg: 'Certifique-se de preencher todos os campos e datas', icon: 'error' })
        }
        else if (this.event.end_time && this.event.start_time && this.dates.length > 0 && this.event.name) {
          let start_of = this.$dayjs(`${this.dates[0]} ${this.event.start_time}`)
          let end_of = this.dates.length > 1 ? this.$dayjs(`${this.dates[1]} ${this.event.end_time}`) : this.$dayjs(`${this.dates[0]} ${this.event.end_time}`)

          let event = {
            ...this.event,
            category: category,
            start_at: start_of,
            end_at: end_of,
            start_time: start_of,
            end_time: end_of,
            participant_ids: participants
          }
          this.$emit('createEvent', event, this.event_detail_attributes)
        }

      } else if (this.validateForm() && !route_schedule) {
        let event = {
          ...this.event,
          category: category,
          participant_ids: participants
        }
        this.$emit('createEvent', event, this.event_detail_attributes)
      }
    },
    swallConfirmation(data) {
      return this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        title: data.msg,
        icon: data.icon, //[ success, error, warning, info, question]
      }).then(r => {
        return r.value
      });
    },
    verifyPickerTime() {
      this.$dayjs(`${this.event.end_at} ${this.event.end_time}`).isAfter(`${this.event.start_at} ${this.event.start_time}`) == true ?
        this.is_event_end_after_start = true : this.date_invalid_dialog = true
    },
    handleColor(v) {
      this.event.color = v
    },
    handleDataPickStartAt(v) {
      this.event.start_at = v
      this.is_event_end_after_start = false
      if (this.event.end_at && this.event.start_time && this.event.end_time) {
        this.verifyPickerTime()
      }
    },
    handleDataPickEndAt(v) {
      this.event.end_at = v
      this.is_event_end_after_start = false
      if (this.event.start_at && this.event.start_time && this.event.end_time) {
        this.verifyPickerTime()
      }
    },
    validateForm() {
      return this.$refs.form_info.validate()
    },
    fetchZip(zip) {
      if (!this.loading_zip && (/^[0-9]{8}$/.test(zip.replace(/[.-]/g, '')))) {
        this.loading_zip = true
        cep(zip.replace(/[.-]/g, '')).then(endereco => {
          const { street, neighborhood, city, state } = endereco
          let num = this.event_detail_attributes.address.split('Nº: ')[1] || ''
          this.event_detail_attributes.address = `CEP ${this.event_detail_attributes.zip}, ${street || 'Rua: '}, ${neighborhood || 'Bairro: '}, ${city}, ${state}, Nº: ${num}`
        }).finally(() => {
          this.loading_zip = false
        })
      }
    },
    setStatus() {
      let route = this.$route.name
      if (route == 'NewEvent') return this.event.status = 'waiting'
      if (route == 'NewNegotiation') return this.event.status = 'in_negociation'
      if (route == 'NewScheduleLock') return this.event.status = 'open'
    },
  },
  computed: {
    formatDateToShow() {
      if (this.dates.length > 0) {
        let is_same = this.dates.length > 1 ? this.$dayjs(this.dates[0]).isSame(this.dates[1], 'day') : true

        let s_date = this.event.start_time ? this.$dayjs(this.dates[0]).format(`DD/MM/YYYY [às ${this.event.start_time}]`) : this.$dayjs(this.dates[0]).format(`DD/MM/YYYY`)
        let e_date = !this.event.end_time && !is_same ? this.$dayjs(this.dates[1]).format(`DD/MM/YYYY`) : is_same ? this.event.end_time : this.$dayjs(this.dates[1]).format(`DD/MM/YYYY [até as ${this.event.end_time}]`)

        return e_date ? s_date + ' a ' + e_date : s_date

      } else {
        return 'SELECIONE UMA DATA OU PERÍODO'
      }
    },
    min_date() {
      return this.dates.length > 1 ? this.dates[0] : this.$dayjs().format('YYYY-MM-DD')
    },
    status_items_map() {

      if (this.$route.name == 'NewEvent') return ([
        { text: 'Aguardando', value: 'waiting' },
        { text: 'Confirmado', value: 'open' },
        { text: 'Cancelado', value: 'cancelled' },
        { text: 'Executado', value: 'executed' },
      ])

      if (this.$route.name == 'NewNegotiation') return [
        { text: 'Negociando', value: 'in_negociation' },
        { text: 'Cancelada', value: 'canceled_negociation' },
        { text: 'Arquivada', value: 'filed' },
      ]

    },
  },
  watch: {
    '$route.name'(newValue) {
      if (newValue) {
        this.$refs.form_info.reset()
        this.setStatus()
        this.alert = false
      }
    },
  },
  mounted() {
    this.setStatus()
  },
}
</script>

<style scoped>
>>>.v-date-picker-title__date {
  font-size: 16px !important;
}

>>>.v-picker__title {
  background-color: #82b1ff !important;
}

>>>.v-date-picker-title__date {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

>>>.v-application .primary {
  background-color: #000000 !important;
}

>>>.v-application .primary {
  background-color: #000000 !important;
}

.background-color-def {
  background-color: #82b1ff !important;
}
</style>